/**
 * @fileoverview Barrel exports for the prose-continuer-guided-neutral agent.
 *
 * Guided continuation in deliberately neutral prose: advances the story within
 * a planned chapter structure while leaving voice/style to a downstream pass.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, proseContinuerGuidedNeutralAgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
